import React from "react";

const LeftArrowIcon = () => {
  return (
    <svg
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.29697 10.1227C6.42697 10.2527 6.5 10.429 6.5 10.6128C6.5 10.7967 6.42697 10.973 6.29697 11.103C6.16698 11.233 5.99067 11.306 5.80683 11.306C5.62299 11.306 5.44667 11.233 5.31668 11.103L0.703524 6.48984C0.639014 6.42555 0.587829 6.34916 0.552903 6.26505C0.517978 6.18094 0.5 6.09076 0.5 5.99969C0.5 5.90861 0.517978 5.81844 0.552903 5.73433C0.587829 5.65022 0.639014 5.57383 0.703524 5.50954L5.31668 0.896385C5.44667 0.76639 5.62299 0.693359 5.80683 0.693359C5.99067 0.693359 6.16698 0.76639 6.29697 0.896385C6.42697 1.02638 6.5 1.20269 6.5 1.38653C6.5 1.57037 6.42697 1.74669 6.29697 1.87668L2.17454 5.99911L6.29697 10.1227Z"
        fill="black"
      />
    </svg>
  );
};

export default LeftArrowIcon;
